<template>
	<div
		class="button-container"
		@click="$emit('click', $event)"
		:class="{
			'v-2': buyRentExpVariant === 'variant_2',
			'v-3': buyRentExpVariant === 'variant_3',
		}"
	>
		<div class="button-container__button">
			<div
				class="offer__cta"
				:class="{
					'offer__cta--yellow': !isHighlighted,
					'is-highlighted-row': isHighlighted,
				}"
			>
				<FontAwesomeIcon :icon="faPlay" size="lg" class="play-icon" />

				<span class="offer__cta__text">
					<slot>
						{{ isHighlighted ? $t('WEBAPP_STREAM_FREE') : $t('WEBAPP_STREAM_FOR_FREE') }}
					</slot>
				</span>
			</div>
		</div>

		<div class="offer__detail" v-show="hasPromotionTag">
			<p>{{ $t('WEBAPP_PROMOTED') }}</p>
		</div>
	</div>
</template>

<script setup lang="ts">
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import { useExperiment } from '@/libraries/experiment';

defineProps<{
	isHighlighted?: boolean;
	hasPromotionTag?: boolean;
}>();

const { activeVariantWithControlGroup: buyRentExpVariant } = useExperiment('EXP_MERGE_BUY_RENT');
</script>

<style scoped lang="scss">
.button-container {
	display: flex;
	align-items: flex-end;
	flex-direction: column;
	max-width: inherit;
	min-width: 170px;
	flex-shrink: 0;
	// align-self: flex-end;

	@media (max-width: 1100px) {
		min-width: 150px;
	}

	&__button {
		display: flex;
		flex-direction: column;
		border-radius: 8px;
		min-width: 166px;

		@media (max-width: 1100px) {
			min-width: 110px;
		}

		@media (max-width: 1050px) {
			min-width: 166px;
		}
		&__promo {
			color: #f20000;
			height: 40px;
			border-radius: 8px;
			font-size: 16px;
			font-weight: 900;
			letter-spacing: 0.24px;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}

	.offer__cta {
		height: 40px;
		width: fit-content;
		min-width: 166px;
		padding: 8px 16px;
		border-radius: 8px;
		border: none;
		background: #303740;
		color: var(--jw-grey-200);
		font-size: 16px;
		font-weight: 900;
		letter-spacing: 0.24px;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;

		white-space: nowrap;

		&:hover {
			background: #303740cb;
		}

		@media (max-width: 1100px) {
			min-width: 110px;
		}

		@media (max-width: 1050px) {
			min-width: 166px;
		}

		/* Fallback for @container rule */
		@media (max-width: 750px) {
			width: fit-content;
			padding: 0 16px;
			flex: 0 1 auto;
			margin-inline-start: 0;
		}

		@container offer-container (max-width: 600px) {
			width: fit-content;
			padding: 0 16px;
			flex: 0 1 auto;
			margin-inline-start: 0;
		}

		&--yellow {
			background: var(--jw-yellow-500);
			color: var(--jw-shade-black);

			&:hover {
				background: #fbc500b1;
			}
		}

		.play-icon {
			margin-inline-end: 8px;
		}

		&__text {
			white-space: nowrap;
		}
	}

	.offer__detail {
		padding-top: 12px;

		p {
			margin: 0;
			color: #6f7d90;
			font-size: 14px;
			line-height: 16px;
			letter-spacing: 0.21px;
		}
	}

	.is-highlighted-row {
		margin-top: 0;
	}

	&.v-2,
	&.v-3 {
		align-self: flex-start;
		@media (max-width: 750px) {
			align-items: flex-start;
			justify-self: flex-start;
			align-self: flex-end;
			width: 100%;

			.button-container__button {
				width: 100%;
				.offer__cta {
					width: 100%;
				}
			}
		}

		@container offer-container (max-width: 600px) {
			justify-self: flex-start;
			align-items: flex-start;
			align-self: flex-end;
			width: 100%;

			.button-container__button {
				width: 100%;

				.offer__cta {
					width: 100%;
				}
			}
		}
	}
	&.v-2 {
		@media (max-width: 380px) {
			align-self: flex-start;
		}
	}
}
</style>
